import React from 'react';
import { Modal } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import * as Yup from 'yup';
import { callAdminRefundAmount } from '../../../api-services';
import { useMutation } from 'react-query';
import swal from 'sweetalert';

const RefundModal = ({
  openModalRefund,
  setOpenModalRefund,
  openModalRefundData,
  setOpenModalRefundData,
}) => {
  console.log(
    '🚀 ~ file: RefundModal.js:17 ~ openModalRefundData',
    openModalRefundData,
  );
  const validationSchema = Yup.object().shape({
    reason: Yup.string().required('Required'),
    amount: Yup.number('amount cannot be empty')
      .transform((value) => (isNaN(value) ? undefined : value))
      .nullable()
      .required('Amount is required'),
    // .test('test-amount', 'invalid amount', (val) => {
    //   if (
    //     Number(val).toFixed(2) <
    //     Number(openModalRefundData.total_amount).toFixed(2)
    //   ) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // }),
  });
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      amount: '',
      reason: '',
    },
    resolver: yupResolver(validationSchema),
    mode: 'onSubmit',
  });
  const watchAmount = watch('amount');

  const handleClose = () => {
    setOpenModalRefund(false);
    setOpenModalRefundData({});
    reset();
  };

  const { isLoading, mutateAsync } = useMutation(
    'refund-amount',
    callAdminRefundAmount,
    {
      onSuccess: (data) => {
        swal({
          title: data?.data?.message,
          text: 'Your Amount Refunded Successfully ',
          icon: 'success',
        });
        handleClose();
      },
      onError: (error) => {
        swal({
          title: error?.response?.data?.message,
          type: 'danger',
          icon: 'error',
        });
        reset();
      },
    },
  );

  const handleSubmitForm = async (value) => {
    // await mutateAsync({
    //   ...value,
    //   invoice_number: openModalRefundData?.invoice_number,
    // });
  };

  return (
    <>
      <Modal
        size="md"
        centered
        show={openModalRefund}
        onHide={() => handleClose()}
        keyboard={false}
        backdrop="static"
      >
        <div className="modal-header">
          <h5 className="modal-title ">Refund</h5>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className=" col-md-12">
              <form
                className="m-0 form-fields"
                onSubmit={handleSubmit(handleSubmitForm)}
              >
                <div className="form-group">
                  <input
                    {...register('amount', {
                      validate: {
                        value:
                          Number(watchAmount) <
                          Number(openModalRefundData.total_amount),
                        message: 'amount invalid',
                      },
                    })}
                    type="number"
                    name="amount"
                    maxLength="50"
                    placeholder="Amount"
                    className="form-control"
                  />
                  <p className="error_required">{errors.amount?.message}</p>
                </div>
                <div className="form-group">
                  <textarea
                    {...register('reason')}
                    type="text"
                    name="reason"
                    maxLength="20"
                    required=""
                    placeholder="Reason"
                    className="form-control"
                  />
                  <p className="error_required">{errors.reason?.message}</p>
                </div>
                <div className="form-group text-center mt-4">
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={() => handleClose()}
                  >
                    Close
                  </button>{' '}
                  &nbsp;
                  <button type="submit" className="btn btn-dark-blue">
                    {isLoading ? 'Please wait...' : 'Refund'}
                  </button>
                </div>

                <div className="col-md-12 text-right"></div>
              </form>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default RefundModal;
